import React, { useEffect, useState } from "react";
import { Box, Button, Tab, Tabs } from "@material-ui/core";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { BaseItemState, OverviewCriteria } from "../Ticker2/Ticker2Models";
import FixtureOverviewUtil from "./FixtureOverviewUtil";
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import RoundOverviewUtil from "../RoundOverview/RoundOverviewUtil";
import Ticker2Util from "../Ticker2/Ticker2Util";
import FixtureMappingTable from "./FixtureMappingTable";
import { ActionState, ExtFixtureFilter, ExtFixtureItem, FixtureMapping, FixtureNg, FixtureNgItem } from "./FixtureOverviewModels";
import { Fixture } from "../TeamOverview/TeamOverviewModels";
import { League } from "../LeagueOverview/LeagueModels";
import { GenericResponse, LeagueListItem } from "../CreateRound/CreateRoundModels";
import { ListResponse } from "../api/ApiNgModels";
import { UpdateItemState } from "../CreateSyndicate/CreateSyndicateModels";
import { blue } from "@material-ui/core/colors";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import ExtFixtureTable from "./ExtFixtureTable";
import { RoundOverviewItem } from "../RoundOverview/RoundOverviewModels";
import { TabPanel } from "../Components/TabPanel";
import FixtureNgMappingView from "./FixtureNgMappingView";
import FixtureNgExtView from "./FixtureNgExtView";

interface FixtureNgDetailsProps {
    fixtureNg: FixtureNg;
}
const FixtureNgDetails: React.FC<FixtureNgDetailsProps> = (props) => {
    const [selectedTab, setSelectedTab] = useState(() => 0)

    var item = props.fixtureNg;
    var fixture = props.fixtureNg.fixture;
    var competition = props.fixtureNg.competition;
    var sport = ""
    return (
        <div>
            <h3>Fixture Ng</h3>
            Id: {item.id} | Name: {item.name} | Starting at: {CreateRoundUtil.toGameDateString(item.startingAt)}
            <br/>Competition: {competition ? `${competition.name} (id: ${competition.id})` : "" } | Country: {competition ? `${competition.countryName} (id: ${competition.countryId})` : "" } | Sport: {competition ? `${competition.sportName} (id: ${competition.sportId})` : "" }
            <br/>Home participant: {item.homeParticipant ? `${item.homeParticipant.name} (id: ${item.homeParticipant.id})` : "" } | Away participant: {item.awayParticipant ? `${item.awayParticipant.name} (id: ${item.awayParticipant.id})` : "" }
            <h3>Fixture</h3>
            Id: {fixture ? fixture.id.toString() : ""} | Name: {fixture ? fixture.name : ""} | Starting at: {fixture ? CreateRoundUtil.toGameDateString(fixture.startingAt) : ""} | Status: {fixture ? fixture.status : ""}
            <br/>League: {fixture ? `${fixture.leagueTitle} (id: ${fixture.leagueId})` : "" }
            
            <div>
                <Tabs value={selectedTab}
                    onChange={(ev, value) => { setSelectedTab(value) }}
                >
                    <Tab label="FixtureNg mappings" />
                    <Tab label="Ext fixtures" />
                </Tabs>
                <TabPanel value={selectedTab} index={0}>
                    <FixtureNgMappingView fixtureNg={props.fixtureNg} />
                </TabPanel> 
                <TabPanel value={selectedTab} index={1}>
                    <FixtureNgExtView fixtureNg={props.fixtureNg}  />
                </TabPanel>
            </div>
        </div>
    );
};

export default FixtureNgDetails;

